import { examHolder } from "../Exam";
import { submitAbSelf } from "../SelfRating/SelfRating";
import { submitAb } from "../Submit/SaveAnswer";


export function addSubmissionListeners(){
    const holder = $(examHolder);
    $(holder).on("click", ".submit-ab", function(e){

        const status = $("#submit-button").attr('data-status'); // take constant button status
        e.preventDefault();
        const confirmed = confirm("Bist du sicher, dass du deine Antworten abgeben möchtest?");
        if (confirmed){
            if (status == 'self'){
                submitAbSelf($(this));
            } else if (status == 'submit'){
                submitAb($(this));
            }
            $(this).prop('disabled', true);
            setTimeout(() => {
                $(this).prop('disabled', false);
            }, 1500)
        }
    })

    $("#submit-button").on("click", function(e){
        e.preventDefault();
        const confirmed = confirm("Bist du sicher, dass du deine Antworten abgeben möchtest?");
        if (confirmed){
            const status = $(this).attr('data-status');
            if (status == 'self'){
                submitAbSelf($(this));
            } else if (status == 'submit'){
                submitAb($(this));
            }

            $(this).prop('disabled', true);
            setTimeout(() => {
                $(this).prop('disabled', false);
            }, 1500)
        }
    })
}